import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import type { PaginatedInvoice } from "contracts/Invoice";
import type { Pagination } from "contracts/Pagination";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess", "onFailure"],
    success: ["data", "pagination"],
    failure: ["errorMessage"],
    softReset: [],
    reset: [],
  },
  {
    prefix: "PAGINATE_PENDING_RELEASE_",
  }
);

export interface PaginatePendingReleaseState {
  data: PaginatedInvoice[];
  pagination?: Pagination;
  loading: boolean;
  errorMessage: string | null;
}

export interface PaginatePendingReleaseRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: PaginatedInvoice[];
  pagination: Pagination;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: PaginatePendingReleaseState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: PaginatePendingReleaseState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: PaginatePendingReleaseState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
    pagination: { $set: action.pagination },
  });

const failure = (state: PaginatePendingReleaseState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: PaginatePendingReleaseState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = (state: PaginatePendingReleaseState) =>
  update(state, {
    data: { $set: {} },
  });

export const paginatePendingRelease = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const PaginatePendingReleaseTypes = Types;
export const PaginatePendingReleaseActions = Creators;
